import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import {
  Box,
  Container,
  Stack,
  Typography,
  Button,
  TextField,
  Grid,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ReactSelect from "react-select";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SweetAlert from "sweetalert2";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Insurance name is required"),
  emailAddress: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  phoneNo: Yup.string()
    .matches(/^\d{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  //   shortName: Yup.string(),
  //   type: Yup.string(),
  //   fax: Yup.string(),
  //   address: Yup.string(),
  //   city: Yup.string(),
  //   state: Yup.string(),
  //   zip: Yup.string(),
  //   id: Yup.number().default(0),
  //   practiceId: Yup.number().default(0),
});

const FacilitiesRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const FacilitiesId = location.state?.FacilitiesId || 0; // Retrieve insuranceId from location.state

  const token = localStorage.getItem("Thyra_Token");
  const practiceId = localStorage.getItem("practiceid");
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const fields = [
    "id",
    "practice_id",
    "name",
    "shortName",
    "payerId",
    "type",
    "phone",
    "fax",
    "address",
    "emailAddress",
    "city",
    "state",
    "zipCode",
    "defaultFacility",
    "defaultPOS",
    "npi",
  ];

  const defaultValues = {
    id: 0,
    practice_id: Number(practiceId) || 0,
    name: "",
    shortName: "",
    type: "",
    phoneNo: "",
    fax: "",
    email: "",
    emailAddress: "",
    city: "",
    address: "",
    state: "",
    zipCode: "",
    defaultFacility: "",
    defaultPOS: "",
    npi: "",
  };

  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const [submitting, setSubmitting] = useState(false);
  const [isDialogOpenResp, setDialogOpenResp] = useState(false);

  console.log("uzair ahmed insuranceId:", FacilitiesId); // Debugging

  useEffect(() => {
    if (FacilitiesId > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Facilities/getFacilityById?id=${FacilitiesId}`,
          { headers }
        )
        .then((response) => {
          const data = response; // Adjust based on your API response structure
          const fieldMapping = {
            id: data.id,
            practice_id: data.practice_id,
            name: data.name,
            shortName: data.shortName || "",
            type: data.type || "",
            phoneNo: data.phoneNo,
            fax: data.fax || "",
            emailAddress: data.emailAddress,
            address: data.address || "",
            city: data.city || "",
            state: data.state || "",
            zipCode: data.zipCode || "",
            defaultFacility: data.defaultFacility || "",
            defaultPOS: data.defaultPOS || "",
            npi: data.npi || "",
          };

          Object.entries(fieldMapping).forEach(([field, value]) => {
            setValue(field, value);
          });
        })
        .catch((error) => {
          console.error("Error fetching insurance data:", error);
        });
    }
  }, [FacilitiesId, setValue]);

  const onSubmit = (data) => {
    if (submitting) return;
    setSubmitting(true);

    axios
      .post(`${process.env.REACT_APP_API_URL}/Facilities/addFacility`, data, {
        headers,
      })
      .then((response) => {
        if (response.id) {
          setDialogOpenResp(true);
          setTimeout(() => {
            navigate("/Facilities");
            setDialogOpenResp(false);
          }, 1000);
        }
        setSubmitting(false);
      })
      .catch((error) => {
        console.error("Submission error:", error.response || error);
        SweetAlert.fire({
          icon: "error",
          title: "Oops...",
          text:
            error.response?.data?.message || "Failed to submit insurance data!",
        });
        setSubmitting(false);
      });
  };

  const handleCancel = () => {
    navigate("/Facilities");
  };
  const labelStyles = {
    fontSize: "14px",
    fontWeight: "500",
    color: "#000",
    marginBottom: "8px",
    display: "block",
  };

  // Consistent TextField styling
  const textFieldStyles = {
    "& .MuiInputBase-root": {
      height: "40px",
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#d1d1d1",
      },
      "&:hover fieldset": {
        borderColor: "#2B7B7E",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#2B7B7E",
      },
    },
  };
  const posOptions = [
    { value: "1", label: "Pharmacy" },
    { value: "2", label: "Unassigned" },
    { value: "3", label: "School" },
    { value: "4", label: "Homeless Shelter" },
    { value: "5", label: "Indian Health Service Free-standing Facility" },
    { value: "6", label: "Indian Health Service Provider-based Facility" },
    { value: "7", label: "Tribal 638 Free-standing Facility" },
    { value: "8", label: "Tribal 638 Provider-based Facility" },
    { value: "9", label: "Prison/ Correctional Facility" },
    { value: "10", label: "Unassigned" },
    { value: "11", label: "Office" },
    { value: "12", label: "Home" },
    { value: "13", label: "Assisted Living Facility" },
    { value: "14", label: "Group Home" },
    { value: "15", label: "Mobile Unit" },
    { value: "16", label: "Temporary Lodging" },
    { value: "17", label: "Walk-in Retail Health Clinic" },
    { value: "18", label: "Place of Employment-Worksite" },
    { value: "19", label: "Off Campus-Outpatient Hospital" },
    { value: "20", label: "Urgent Care Facility" },
    { value: "21", label: "Inpatient Hospital" },
    { value: "22", label: "On Campus-Outpatient Hospital" },
    { value: "23", label: "Emergency Room – Hospital" },
    { value: "24", label: "Ambulatory Surgical Center" },
    { value: "25", label: "Birthing Center" },
    { value: "26", label: "Military Treatment Facility" },
    { value: "27,30", label: "Unassigned" },
    { value: "31", label: "Skilled Nursing Facility" },
    { value: "32", label: "Nursing Facility" },
    { value: "33", label: "Custodial Care Facility" },
    { value: "34", label: "Hospice" },
    { value: "35,40", label: "Unassigned" },
    { value: "41", label: "Ambulance Land" },
    { value: "42", label: "Ambulance – Air or Water" },
    { value: "43,48", label: "Unassigned" },
    { value: "49", label: "PIndependent Clinic" },
    { value: "50", label: "Federally Qualified Health Center" },
    { value: "51", label: "Inpatient Psychiatric Facility" },
    { value: "52", label: "Psychiatric Facility-Partial Hospitalization" },
    { value: "53", label: "Community Mental Health Center" },
    {
      value: "54",
      label:
        "Intermediate Care Facility/ Individuals with Intellectual Disabilities",
    },
    { value: "55", label: "Residential Substance Abuse Treatment Facility" },
    { value: "56", label: "Psychiatric Residential Treatment Center" },
    {
      value: "57",
      label: "Non-residential Substance Abuse Treatment Facility",
    },
    { value: "58,59", label: "Unassigned" },
    { value: "60", label: "Mass Immunization Center" },
    { value: "61", label: "Comprehensive Inpatient Rehabilitation Facility" },
    { value: "62", label: "Comprehensive Outpatient Rehabilitation Facility" },
    { value: "63,64", label: "Unassigned" },
    { value: "65", label: "End-Stage Renal Disease Treatment Facility" },
    { value: "66,70", label: "Unassigned" },
    { value: "71", label: "Public Health Clinic" },
    { value: "72", label: "Rural Health Clinic" },
    { value: "73,80", label: "Unassigned" },
    { value: "81", label: "Independent Laboratory" },
    { value: "82,98", label: "Unassigned" },
    { value: "99", label: "Other Place of Service" },
  ];
  return (
    <Container sx={{ pt: 10, pb: 4, maxWidth: "lg" }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#2B7B7E" }}>
          Facilities Registration
        </Typography>
      </Box>
      <Dialog
        open={isDialogOpenResp}
        onClose={() => setDialogOpenResp(false)}
        PaperProps={{
          style: {
            marginRight: "5px",
            float: "right",
            marginTop: "5px",
            color: "red",
            cursor: "pointer",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: "8px",
            width: "500px",
          }}
        >
          <CheckCircleIcon style={{ fontSize: "100px", color: "green" }} />
          <h5
            style={{
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "normal",
              color: "#444444",
            }}
          >
            Facilities {FacilitiesId > 0 ? "updated" : "added"} successfully
          </h5>
          <DialogContent />
        </div>
      </Dialog>
      <Box
        sx={{
          bgcolor: "#FFFFFF",
          borderRadius: "12px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
          p: 4,
        }}
      >
        <Grid container spacing={2}>
        <Grid className="row">
         
          {/* Full Name */}
            <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>
              Full Name</Typography>
            <TextField
              {...register("name", {
                required: "Please enter your Name",
              })}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Full Name"
              error={!!errors.name}
              helperText={errors.name?.message}
              sx={textFieldStyles}
            />
          </Grid>

          {/* Shirtname */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>Short Name</Typography>
            <TextField
              {...register("shortName")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Org Business"
              sx={textFieldStyles}
            />
          </Grid>
          {/* type */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>Type</Typography>
            <TextField
              {...register("type")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Type"
              sx={textFieldStyles}
            />
          </Grid>
          {/* Email Address */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>Email Address</Typography>
            <TextField
              {...register("emailAddress")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Email Address"
              sx={textFieldStyles}
            />
          </Grid>
          {/* Phone No */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>Phone No</Typography>
            <TextField
              {...register("phoneNo")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Phone no"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
              }}
              sx={textFieldStyles}
            />
          </Grid>

          {/* Fax */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>Fax</Typography>
            <TextField
              {...register("fax")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Fax"
              sx={textFieldStyles}
            />
          </Grid>

          {/* Address */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>Address</Typography>
            <TextField
              {...register("address")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Address"
              sx={textFieldStyles}
            />
          </Grid>

          {/* City */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>City</Typography>
            <TextField
              {...register("city")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your City"
              sx={textFieldStyles}
            />
          </Grid>

          {/* Zip Code */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>Zip Code</Typography>
            <TextField
              {...register("zipCode")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Zip Code"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 9);
              }}
              sx={textFieldStyles}
            />
          </Grid>
          {/* State */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>State</Typography>
            <Controller
              name="state"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={[
                    { value: "AL", label: "ALABAMA" },
                    { value: "AK", label: "ALASKA" },
                    { value: "AS", label: "AMERICAN SAMOA" },
                    { value: "AZ", label: "ARIZONA" },
                    { value: "AR", label: "ARKANSAS" },
                    { value: "CA", label: "CALIFORNIA" },
                    { value: "CO", label: "COLORADO" },
                    { value: "CT", label: "CONNECTICUT" },
                    { value: "DE", label: "DELAWARE" },
                    { value: "DC", label: "DISTRICT OF COLUMBIA" },
                    { value: "FL", label: "FLORIDA" },
                    { value: "GA", label: "GEORGIA" },
                    { value: "GU", label: "GUAM" },
                    { value: "HI", label: "HAWAII" },
                    { value: "ID", label: "IDAHO" },
                    { value: "IL", label: "ILLINOIS" },
                    { value: "IN", label: "INDIANA" },
                    { value: "IA", label: "IOWA" },
                    { value: "KS", label: "KANSAS" },
                    { value: "KY", label: "KENTUCKY" },
                    { value: "LA", label: "LOUISIANA" },
                    { value: "ME", label: "MAINE" },
                    { value: "MD", label: "MARYLAND" },
                    { value: "MA", label: "MASSACHUSETTS" },
                    { value: "MI", label: "MICHIGAN" },
                    { value: "MN", label: "MINNESOTA" },
                    { value: "MS", label: "MISSISSIPPI" },
                    { value: "MO", label: "MISSOURI" },
                    { value: "MT", label: "MONTANA" },
                    { value: "NE", label: "NEBRASKA" },
                    { value: "NV", label: "NEVADA" },
                    { value: "NH", label: "NEW HAMPSHIRE" },
                    { value: "NJ", label: "NEW JERSEY" },
                    { value: "NM", label: "NEW MEXICO" },
                    { value: "NY", label: "NEW YORK" },
                    { value: "NC", label: "NORTH CAROLINA" },
                    { value: "ND", label: "NORTH DAKOTA" },
                    { value: "MP", label: "NORTHERN MARIANA IS" },
                    { value: "OH", label: "OHIO" },
                    { value: "OK", label: "OKLAHOMA" },
                    { value: "OR", label: "OREGON" },
                    { value: "PA", label: "PENNSYLVANIA" },
                    { value: "PR", label: "PUERTO RICO" },
                    { value: "PI", label: "RHODE ISLAND" },
                    { value: "SC", label: "SOUTH CAROLINA" },
                    { value: "SD", label: "SOUTH DAKOTA" },
                    { value: "TN", label: "TENNESSEE" },
                    { value: "TX", label: "TEXAS" },
                    { value: "UT", label: "UTAH" },
                    { value: "VT", label: "VERMONT" },
                    { value: "VA", label: "VIRGINIA" },
                    { value: "VI", label: "VIRGIN ISLANDS" },
                    { value: "WA", label: "WASHINGTON" },
                    { value: "WV", label: "WEST VIRGINIA" },
                    { value: "WI", label: "WISCONSIN" },
                    { value: "WY", label: "WYOMING" },
                  ]}
                  value={
                    getValues("state")
                      ? {
                          label: getValues("state"),
                          value: getValues("state"),
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setValue("state", selectedOption?.value || "")
                  }
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "40px",
                      fontSize: "14px",
                      borderColor: "#d1d1d1",
                      "&:hover": {
                        borderColor: "#2B7B7E",
                      },
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 5000,
                    }),
                  }}
                />
              )}
            />
          </Grid>
          {/* Zip Code */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}>NPI</Typography>
            <TextField
              {...register("npi")}
              fullWidth
              variant="outlined"
              size="small"
              placeholder="Enter your Npi"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 9);
              }}
              sx={textFieldStyles}
            />
          </Grid>
          {/* Place of Service */}
          <Grid className="col-md-4">
            <Typography sx={{ fontSize: "0.875rem", color: "#77A2A7", mt: 2 }}> Place of Service</Typography>
            <Controller
              name="defaultPOS"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={posOptions}
                  value={
                    posOptions.find(
                      (option) => option.value === getValues("defaultPOS")
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    setValue("defaultPOS", selectedOption?.value || "")
                  }
                />
              )}
            />
          </Grid>
        </Grid>
            </Grid>
        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            mt: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCancel}
            sx={{
              width: "100px",
              height: "35px",
              backgroundColor: "#2B7B7E",
              color: "white",
              borderRadius: "80px",
              fontSize: "14px",
              "&:hover": { backgroundColor: "#1a1a1a" },
            }}
          >
            <CancelOutlinedIcon
              fontSize="medium"
              style={{ color: "red", paddingRight: "5px" }}
            />
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            disabled={submitting}
            sx={{
              width: "100px",
              height: "35px",
              backgroundColor: "#2B7B7E",
              color: "white",
              borderRadius: "80px",
              fontSize: "14px",
              "&:hover": { backgroundColor: "#1a1a1a" },
            }}
          >
            <SaveOutlinedIcon sx={{ color: "white", mr: 1 }} />
            Save
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default FacilitiesRegistration;
